import { render, staticRenderFns } from "./ConfirmCredenc.vue?vue&type=template&id=5dcf835b"
import script from "./ConfirmCredenc.vue?vue&type=script&lang=js"
export * from "./ConfirmCredenc.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCredenc.vue?vue&type=style&index=0&id=5dcf835b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports